import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      borderTop: '1px solid var(--border-light)',
      padding: '60px 40px 40px',
      background: 'var(--bg-primary)'
    }}>
      <div className="container">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '48px',
          marginBottom: '48px',
          maxWidth: '1000px',
          margin: '0 auto 48px'
        }}>
          {/* Brand */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>
              Honey Sofia
            </h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Sydney Based<br />
              Discreet • Refined • Unforgettable
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="body-regular" style={{ marginBottom: '16px', fontWeight: '600' }}>
              Contact
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <a 
                href="mailto:contacthoneysofia@gmail.com" 
                className="body-small"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s ease' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--burgundy)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                contacthoneysofia@gmail.com
              </a>
              <a 
                href="sms:0401627005" 
                className="body-small"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s ease' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--burgundy)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                0401 627 005
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="body-regular" style={{ marginBottom: '16px', fontWeight: '600' }}>
              Follow
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a 
                href="https://bsky.app/profile/honeysofia.bsky.social" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: 'var(--burgundy)',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"/>
                </svg>
                Bluesky (Follow me here!)
              </a>
              <a 
                href="https://throne.com/honeysofia" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--burgundy)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 7h-7l-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/>
                  <path d="M12 11v6m-3-3h6"/>
                </svg>
                Wishlist
              </a>
            </div>
          </div>

          {/* Show Appreciation */}
          <div>
            <h4 className="body-regular" style={{ marginBottom: '16px', fontWeight: '600' }}>
              Spoil Me
            </h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '12px', lineHeight: '1.6' }}>
              Feeling generous? Your appreciation means the world.
            </p>
            <div style={{ 
              padding: '12px 16px',
              background: 'rgba(90, 30, 43, 0.05)',
              border: '1px solid rgba(90, 30, 43, 0.1)',
              marginBottom: '8px'
            }}>
              <p className="body-small" style={{ margin: 0, fontWeight: '500', color: 'var(--burgundy)' }}>
                Beem: @honeysofia
              </p>
            </div>
            <a 
              href="https://throne.com/honeysofia" 
              target="_blank" 
              rel="noopener noreferrer"
              className="body-small"
              style={{ 
                color: 'var(--text-secondary)', 
                textDecoration: 'underline',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--burgundy)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
            >
              Or browse my wishlist
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div style={{ 
          textAlign: 'center',
          paddingTop: '32px',
          borderTop: '1px solid var(--border-light)'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            © 2026 Honey Sofia. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
